import { useCallback } from 'react';
import { MessageStatus } from '../services/messageQueueService';
import logger from '../utils/logger';

const useCancelUnsentMessages = ({
  queueSnapshot,
  cancelPendingMessage,
  dismissQueuedMessage,
  roomId,
}) => {
  return useCallback(() => {
    const unsentItems = queueSnapshot.filter(({ status }) => status === MessageStatus.UNSENT);

    if (unsentItems.length === 0) {
      return;
    }

    unsentItems.forEach(({ id, txnId }) => {
      if (txnId) {
        const wasCancelled = cancelPendingMessage(txnId);
        if (!wasCancelled) {
          logger.warn('[useCancelUnsentMessages] Failed to cancel pending event for unsent queue item', {
            roomId,
            itemId: id,
            txnId,
          });
        }
      }

      dismissQueuedMessage(id);
    });
  }, [cancelPendingMessage, dismissQueuedMessage, queueSnapshot, roomId]);
};

export default useCancelUnsentMessages;
